import { JsonDataItem, TaskTypes } from 'types';
import { baseQuery } from '../baseQuery';

export const getTasks = async ({
  userId,
  searchValue,
  filterBy,
  status,
  taskType,
  page,
  taskSource,
  pageSize,
  ticketType,
}: JsonDataItem) => {
  const queryParams: string[] = [];

  // Transform Task id value for backend
  let taskTypeIdArray: number[] = [];
  if (taskType === TaskTypes.Tickets) {
    if (ticketType) {
      // Use ticket type id as a task id if provided
      taskTypeIdArray = [ticketType];
    } else {
      // Use multiple reuiqred types if only tickets are requested
      taskTypeIdArray = [TaskTypes.Tickets, 2];
    }
  } else if (Array.isArray(taskType)) {
    // Support arrays if id passed as such type
    taskTypeIdArray = taskType;
  } else if (typeof taskType === 'number') {
    // Transform into array if single type has been requested
    taskTypeIdArray = [taskType];
  }
  // Add each task_type_id[] (required param)
  taskTypeIdArray.forEach((id) => queryParams.push(`task_type_id[]=${id}`));

  // Optional params and filters
  if (userId) queryParams.push(`user_ID=${userId}`);
  if (status !== undefined) queryParams.push(`status=${status}`);
  if (page) queryParams.push(`page=${page}`);
  if (pageSize) queryParams.push(`per_page=${pageSize}`);
  if (filterBy && searchValue) queryParams.push(`${filterBy}=${searchValue}`);

  // Task-type-specific params
  if (taskType === TaskTypes.Callbacks && taskSource) {
    queryParams.push(`source=${taskSource}`);
  }

  const queryString = queryParams.join('&');
  const data = await baseQuery(`tasks?${queryString}`);

  return data;
};
